import { render, staticRenderFns } from "./writtenScore.vue?vue&type=template&id=1338d26a&scoped=true"
import script from "./writtenScore.vue?vue&type=script&lang=js"
export * from "./writtenScore.vue?vue&type=script&lang=js"
import style0 from "./writtenScore.vue?vue&type=style&index=0&id=1338d26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338d26a",
  null
  
)

export default component.exports